import { Injectable } from '@angular/core';

import { RequestService } from '../request.service';


@Injectable()
export class LocalesService {

  constructor(protected requestService: RequestService) {
   }

  getAll(): Promise<any[]> {
    return this.requestService.makeRequest({},'/info/locales').then((response: any) => response.json());
  };

}



// WEBPACK FOOTER //
// ./src/app/services/locales/locales.service.ts